import { Directive, Host, HostBinding } from '@angular/core';
import { RouterLinkActive } from '@angular/router';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[routerLinkActive]',
    standalone: false
})
export class CmCurrentLinkDirective {
	constructor(@Host() private readonly rla: RouterLinkActive) {}

	@HostBinding('attr.aria-current') get ariaCurrent() {
		return this.rla.isActive ? 'page' : null;
	}
}
